export default class TemplateAvailableLocations {
    constructor(container, options) {
        const defaultOptions = {
            states: '.list-states',
            tabStates: '.region-tabs-container .list-states',
            stateItems: '.list-states .state',
            desktop: '.venue-selector',
            mobile: '.venue-selector-mobile',
            inputText: '.input-text',
            venue: 'venue',
            body: 'body'
        };
        this.options = Object.assign({}, defaultOptions, options);
        this.body = document.querySelector(this.options.body)
        this.container = document.querySelector(container);
        this.statesContainer = this.container.querySelector(this.options.states);
        this.tabStates = this.container.querySelector(this.options.tabStates);
        this.stateItems = this.container.querySelectorAll(this.options.stateItems);
        this.venueSelectorDesktop = this.container.querySelector(this.options.desktop);
        this.venueSelectorMobile = this.container.querySelector(this.options.mobile);
        this.inputTextElement = this.container.querySelector(this.options.inputText);
        
        this.setEvents();
        this.onLoad();
    }
    
    setEvents() {
        let self = this;
        this.container.addEventListener('blur', this.hideVenueSelectorDisplay.bind(this));
        
        this.stateItems.forEach(elem => {
            elem.addEventListener('click', function(event) {
                self.clickState(event, this);
                self.hideVenueSelectorDisplay();
            });
        });
    }
    
    onLoad() {
        if (this.tabStates !== null) {
            let firstState = this.tabStates.children[0];
            firstState.classList.add('active');
            this.filterStateItems(firstState.dataset.id);
    
            this.inputTextElement.textContent = firstState.dataset.id;
        }
    }
    
    clickState(event, element) {
        let id = element.dataset.id;
        this.stateItems.forEach(elem => {
            elem.classList.remove('active');
        });
        element.classList.add('active');
        this.body.classList.remove('disable-scrolling')
        this.filterStateItems(id);

        if (this.inputTextElement !== null) {
            this.inputTextElement.textContent = element.textContent;
        }
    }
    
    filterStateItems(id) {
        var venues = document.getElementsByClassName(this.options.venue);
        
        for (let i = 0; i < venues.length; i++) {
            this.filterStateItemsRemoveClass(venues[i], 'show');
            // TODO update this to support states
            if (venues[i].dataset.region == id) {
                this.filterStateItemsAddClass(venues[i], 'show');
            }
        }
    }

    filterStateItemsAddClass(element, name) {
        var i;
        var arr1;
        var arr2;

        arr1 = element.className.split(" ");
        arr2 = name.split(" ");

        for (i = 0; i < arr2.length; i++) {
            if (arr1.indexOf(arr2[i]) == -1) {
                element.className += " " + arr2[i];
            }
        }
    }

    filterStateItemsRemoveClass(element, name) {
        var i;
        var arr1;
        var arr2;

        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for (i = 0; i < arr2.length; i++) {
            while (arr1.indexOf(arr2[i]) > -1) {
                arr1.splice(arr1.indexOf(arr2[i]), 1);
            }
        }
        element.className = arr1.join(" ");
    }

    getVenueSelector() {
        let windowWidth = window.innerWidth
        if (windowWidth >= 768) {
            return this.venueSelectorDesktop;
        }
        else {
            return this.venueSelectorMobile;
        }
    }

    hideVenueSelectorDisplay() {
        let venueSelector = this.getVenueSelector();
        if (venueSelector !== null && venueSelector.classList.contains('show')) {
            venueSelector.classList.remove('show');
        }
    }
}